import { Observable, Observer } from "rxjs";
import { ICommand } from "../../modules/records/commands/i-command";
import { RecordsManager } from "../../modules/records/records-manager";

export class DownloadDeletedCommand<
  T extends object & { isDisabled?: boolean },
  S extends {
    downloadDeleted: (el: T, elastic: boolean, args: unknown) => Observable<any>;
  }
> implements ICommand<T, S>
{
  private receiver!: RecordsManager<T>;
  type: "primary" | "warn" | "accent" = "accent";
  label = "downloadDeleted";
  icon = "get_app";
  layout: "flat" | undefined;
  isLoading = false;
  isElastic: boolean = false;
  private observer: Observer<unknown> = {
    next: (_) => (this.isLoading = false),
    error: (_) => (this.isLoading = false),
    complete: () => {},
  };
  constructor(public service: S, elastic?: boolean) {
    this.isElastic = elastic != undefined;
  }
  execute(el: T) {
    this.isLoading = true;
    this.service.downloadDeleted(el, this.isElastic, this.receiver?.extraFilterSbj.value).subscribe(this.observer);
  }

  setReceiver(receiver: RecordsManager<T>) {
    this.receiver = receiver;
  }

  isDisabled(el: T) {
    return this.receiver?.isLoading || this.isLoading || el?.isDisabled || false;
  }
}
